<script lang="ts">
  import Collapse from "$lib/admin/components/blocks/helpers/Collapse.svelte";
  import type { IntroProps } from "@/src/types/components/Intro";

  export let props: IntroProps;
  export let methodology: boolean = false;
  export let methodologyText: string = "";
  export let recentChanges: boolean = false;
  export let recentChangesList: string[] = [];
  export let crm: boolean = false;
  export let crmText: string = "";

  let cardContent: HTMLElement;

  $: methodology = props.methodology || methodology;
  $: methodologyText = props.methodologyText || methodologyText;
  $: recentChanges = props.recentChanges || recentChanges;
  $: recentChangesList = props.recentChangesList || recentChangesList;
  $: crm = props.crm || crm;
  $: crmText = props.crmText || crmText;
</script>

<div class="content-grid bg-brand-light text-white m-0 py-4" id="block-intro">
  <div class="flex flex-col md:flex-row gap-4">
    {#if crm}
      <div class="w-full">
        <div
            class="h-[54px] rounded-lg bg-white text-black p-4 cursor-pointer text-base font-bold flex items-center justify-between">
          {crmText}
        </div>
      </div>
    {/if}

    <div class="flex flex-col md:flex-row gap-4 w-full items-start">
      {#if methodology}
        <div class="w-full {recentChanges ? 'md:w-1/2' : ''}">
          <Collapse title="Our goal" icon="rocket">
            <div class="p-0 px-5 pb-5">
              {@html methodologyText}
            </div>
          </Collapse>
        </div>
      {/if}

      {#if recentChanges}
        <div class="w-full {methodology ? 'md:w-1/2' : ''}">
          <Collapse title="Recent changes" icon="clock">
            <ul class="list-disc pl-10 pr-5 pb-5 m-0 ml-5">
              {#each recentChangesList as item}
                <li>{@html item}</li>
              {/each}
            </ul>
          </Collapse>
        </div>
      {/if}
    </div>
  </div>
</div>
